module.exports = __webpack_public_path__ + "static/media/authIcon.d2f26142.svg";